import { MemberAlias } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import React, { useMemo, useRef } from 'react'
import { View } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import { AliasSlug } from './slug'

interface Props {
  memberAliases: MemberAlias[] | undefined
  onAliasRemoved?(alias: MemberAlias): void
}

export function MemberAliasSlugList({ memberAliases, onAliasRemoved }: Props) {
  const styles = useStyles()
  const list = useRef<FlatList | null>(null)
  const sortedMemberAliases = useMemo(
    () => (memberAliases ? [...memberAliases].sort() : []),
    [memberAliases]
  )

  return (
    <View>
      <FlatList
        style={styles.container}
        data={sortedMemberAliases}
        renderItem={({ item }) => (
          <AliasSlug alias={item} onRemoved={onAliasRemoved} />
        )}
        keyExtractor={(item: MemberAlias) => item}
        horizontal
        onContentSizeChange={() =>
          list.current?.scrollToEnd({ animated: true })
        }
        ref={ref => {
          list.current = ref
        }}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 0,
    height: 60,
  },
}))
